import * as React from "react";
import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {FilingLocation, PaginatedFilingLocations, SharedFile} from "../../models";
import * as microsoftTeams from "@microsoft/teams-js";
import {get} from "../../api";
import {NetworkState} from "../ApiCallState";
import {TeamsApiService} from "../../services/teams/TeamsApiService";
import {TeamsGetTeamsChannelsRequest} from "../../services/teams/TeamsGetTeamsChannelsRequest";

export interface IDocumentsState extends ITeamsBaseComponentState {
    tenantId: string;
    teamsId: string;
    channelId: string;
    userId: string;
    teamsChannelsRetrievalState: NetworkState;
    teamChannels: PaginatedFilingLocations;
    errorMessage: string;
    sharedFiles: SharedFile[];
    loadingSharedFiles: boolean;
}

export const SharedDocumentsContext: React.Context<SharedDocumentsContextProps> = React.createContext({
    theme: null,
    tenantId: "",
    teamsId: "",
    channelId: "",
    userId: "",
    teamsChannelsRetrievalState: NetworkState.Idle,
    sharedFiles: [],
    teamChannels: null,
    loadingSharedFiles: true,
    errorMessage: null,
    getSharedFiles: () => {},
    getTeamsChannels: () => {},
    setParentState: () => {},
});

export interface SharedDocumentsContextProps extends IDocumentsState {
    getSharedFiles: () => void;
    getTeamsChannels: () => void;
    setParentState: (state: Partial<IDocumentsState>) => void;
}

export interface IDocumentsProps {
    children: React.ReactElement;
    clientCollabLicensed: boolean;
}

export class SharedDocuments extends TeamsBaseComponent<IDocumentsProps, IDocumentsState> {
    teamsApiService = new TeamsApiService();

    constructor(props: IDocumentsProps) {
        super(props);
        this.state = {
            theme: null,
            tenantId: this.getQueryVariable("tenantId"),
            teamsId: this.getQueryVariable("teamsId"),
            channelId: this.getQueryVariable("channelId"),
            userId: this.getQueryVariable("userId"),
            teamsChannelsRetrievalState: NetworkState.Idle,
            sharedFiles: [],
            teamChannels: null,
            loadingSharedFiles: true,
            errorMessage: null,
        };
    }

    public async componentWillMount(): Promise<void> {
        microsoftTeams.initialize();
        if (this.props.clientCollabLicensed) {
            this.getSharedFiles();
            this.getTeamsChannels();
        }
    }

    public getTeamsChannels() {
        const request: TeamsGetTeamsChannelsRequest = {
            channelId: this.state.channelId,
            externalTeamId: null,
            recentDocs: false,
            teamId: this.state.teamsId,
            tenantId: this.state.tenantId,
            userId: this.state.userId,
        };

        if (this.state.teamsChannelsRetrievalState != NetworkState.Success)
            this.setState({teamsChannelsRetrievalState: NetworkState.Loading});

        this.teamsApiService.getTeamsChannels(
            request,
            "Teams channels retrieval failed.",
            (response) =>
                this.setState({
                    teamChannels: {Page: response as FilingLocation[], PagingToken: null, Errors: null},
                    teamsChannelsRetrievalState: NetworkState.Success,
                }),
            (error) => this.setState({errorMessage: error, teamsChannelsRetrievalState: NetworkState.Error})
        );
    }

    public getSharedFiles() {
        get(
            "/api/teamsdmsintegration/GetSharedFiles?teamsId=" + this.state.teamsId + "&tenantId=" + this.state.tenantId
        )
            .then((response) => response.json())
            .then((response) => {
                const sharedFiles = response as SharedFile[];

                this.setState({sharedFiles: sharedFiles, loadingSharedFiles: false});
            });
    }

    public render() {
        return (
            <div>
                <SharedDocumentsContext.Provider
                    value={{
                        ...this.state,
                        getSharedFiles: () => this.getSharedFiles(),
                        getTeamsChannels: () => this.getTeamsChannels(),
                        setParentState: (state: Pick<IDocumentsState, keyof IDocumentsState>) => this.setState(state),
                    }}
                >
                    {this.props.children}
                </SharedDocumentsContext.Provider>
            </div>
        );
    }
}

SharedDocuments.contextType = SharedDocumentsContext;
